/** @format */
import { chain } from '@core/chain';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';

const imagesRoot = 'https://images.dickssportinggoods.com';

export const prodEnvironmentDefaults: any = {
  api: {
    homr: {
      proxy: {
        path: `/dcsg-ngx-home/homr/v2/api/`,
        timeout: DCSG_CONSTANTS.homr.timeout,
      },
      url: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api/',
      scene7Url: 'https://dks.scene7.com/is/image/dksfed/',
      scene7UrlCDN: 'https://dks.scene7.com/is/image/dkscdn/',
    },
    reactMarginals: {
      caliaHeaderUrl: 'https://static-search.dickssportinggoods.com/responsive-header',
      caliaFooterUrl: 'https://static-search.dickssportinggoods.com/footer',
      headerUrl: 'https://static-search.dickssportinggoods.com/responsive-header',
      footerUrl: 'https://static-search.dickssportinggoods.com/footer',
      footerHTMLId: 'responsive-footer',
    },
    spring: {
      microService: {
        breadcrumb: {
          AKSEast: 'https://breadcrumbservice.iso.ap01.pcf.dcsg.com/',
          AKSWest: 'https://breadcrumbservice.iso.ap01.pcf.dcsg.com/',
        },
        category: {
          AKSEast: 'https://categoryservice.iso.ap01.pcf.dcsg.com/',
          AKSWest: 'https://categoryservice.iso.ap01.pcf.dcsg.com/',
        },
        recommendations: {
          AKSEast: 'https://ds-recs-details.dcsg.com',
          AKSWest: 'https://ds-recs-details.dcsg.com',
        },
        seoservice: {
          AKSEast: 'https://seo-api.genextapps01.ue.p.aks.dcsg.com/',
          AKSWest: 'https://seo-api.genextapps01.uw.p.aks.dcsg.com/',
        },
        taxoservice: 'https://browse.dickssportinggoods.com/dcsg-ngx-category/taxo/api/',
      },
      microServiceProxy: {
        recommendations: {
          path: '/api/spring/msvc/ds/v1/',
          timeout: '15000',
        },
      },
    },
    ceops: 'https://ceops.dickssportinggoods.com',
    ecommScripts: `https://${chain.seoIdentifier}.com/ecomm-scripts`,
    dataScience: {
      basePath: '/api/spring/msvc/ds/v1/',
      target: '', // TODO: Find out what the prod url is
    },
    criteo: {
      baseUrl: 'https://d.us.criteo.com/delivery/retailmedia?',
      nolog: 0,
      partnerId: {
        dsg: 25953,
        gg: 35855,
      },
    },
    kraken: {
      gatewayUrl: `https://kraken.genextapps01.ue.p.aks.dcsg.com/`,
      gatewayUrlProxy: {
        path: `/home/kraken/api`,
      },
    },
  },
  images: {
    netstorage: {
      marketing: `${imagesRoot}/marketing/`,
      product: `${imagesRoot}/product/`,
    },
    scene7proxy: {
      marketing: `https://dks.scene7.com/is/image/dksfed/`,
      marketingContent: `https://dks.scene7.com/is/content/dksfed/`,
      product: `https://dks.scene7.com/is/image/dkscdn/`,
    },
  },
  thirdParty: {
    auth0: {
      dsg: {
        enabled: true,
      },
      gg: {
        enabled: true,
      },
      pl: {
        enabled: true,
      },
      g3: {
        enabled: false,
      },
      sm: {
        enabled: false,
      },
      plf: {
        enabled: false,
      },
    },
  },
  baseDomain: {
    dsg: 'https://www.dickssportinggoods.com',
    gg: 'https://www.golfgalaxy.com',
    pl: 'https://www.publiclands.com',
    g3: 'https://www.goinggoing.com',
    sm: 'https://www.sportsmatter.org',
    plf: 'https://www.publiclandsfund.org',
  },
  identityServiceKey: {
    partnerKey: 'MyAccount',
    secretKey: 'PsbiPfwWl9inJxvh3fxN',
  },
  feature: {
    homRAudiences: {
      dsg: false,
      gg: false,
      pl: false,
      g3: false,
      sm: false,
      plf: false,
    },
  },
};
